import { render } from "./Contact.vue?vue&type=template&id=747d4c10&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-747d4c10"

export default script